import { useEffect } from 'react';

export const useTimer = (timerValue, decreaseTimerFunction) => {
    useEffect(() => {
        if (timerValue) {
            const timer = setInterval(() => {
                const value = timerValue - 1;

                decreaseTimerFunction(value);
            }, 1000);

            return () => {
                clearInterval(timer);
            };
        }
    }, [timerValue]);
};
